import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const referralMissionListRBAC = {
  pageID: 'e896146b60bd724d6e805bab09d7b744',
  elementID: {
    ViewPage: 'cc5e8c7cc1d66acc942ee8f7471bbf02',
    CreateMission: 'e0baeb32b26163bf54eb213ec817c526',
    EditMission: '31ccbb9a9598c7f6d9a02560ee6ea9cc',
    DeleteMission: 'c6052ec2c299ad852937ddb4fb4ba9c9',
    UpdateStatusMission: '4ebbc626f9e1ab46a0c2ec5c86008fad',
  },
} as const

export const useRBACReferralMissionListPage = createUseRBAC(referralMissionListRBAC.elementID)

export type UseRBACReferralMissionListPageType = ReturnType<typeof useRBACReferralMissionListPage>
